<template>
  <div class="dealer-homepage-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            经销商信息
          </div>
          <div class="card-content" v-loading="loading">
            <el-form ref="delinfo" v-if="loading==false" :model="delinfo" :rules="editRules" label-width="90px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="客户全称" prop="allname">
                    <el-input v-model="delinfo.allname" maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="店铺名称" prop="allname">
                    <el-input v-model="delinfo.name" maxlength="100" placeholder="例如：杭州乔金斯阿里直营店" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="店面状态" prop="mark">
                    <el-select v-model="delinfo.mark" style="width: 100%">
                      <el-option label="已终止" :value="0"><span style="color:#F56C6C">已终止</span></el-option>
                      <el-option label="已开业" :value="1"></el-option>
                      <el-option label="装修中" :value="2"></el-option>
                      <el-option label="设计中" :value="3"></el-option>
                      <el-option label="已选址" :value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="店铺面积">
                    <el-input v-model="delinfo.storeArea" maxlength="20">
                      <template slot="append">㎡</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="客户电话" prop="tel">
                    <el-input v-model="delinfo.tel" maxlength="11"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="客户传真">
                    <el-input v-model="delinfo.fax" maxlength="20"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="客户邮箱">
                    <el-input v-model="delinfo.email" maxlength="60"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所在地区" prop="city">
                    <el-cascader
                      style="width:100%"
                      v-model="city"
                      :options="cityoptions"
                      filterable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="详细地址" prop="address">
                    <el-input v-model="delinfo.address" maxlength="200" show-word-limit>
                      <el-button slot="append" @click="flushMap" icon="el-icon-place"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="门店定位" prop="gps">
                    <div style="color: #99a9bf;font-size: 12px"><i class="el-icon-info"></i> 当前GPS经纬度：<b>{{ delinfo.lng }},{{ delinfo.lat }}</b></div>
                    <div ref="map" class="txmap" style="width: 100%;height: 300px"></div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="客户级别" prop="level">
                    <el-select v-model="delinfo.level" style="width: 100%">
                      <el-option label="A" value="A"></el-option>
                      <el-option label="B" value="B"></el-option>
                      <el-option label="C" value="C"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预付款比例" prop="depositPer">
                    <el-input v-model="delinfo.depositPer" oninput ="value=value.replace(/[^0-9.]/g,'')">
                      <template slot="append">%，默认 50%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预付款≤" prop="depositLess">
                    <el-input v-model="delinfo.depositLess" oninput ="value=value.replace(/[^0-9.]/g,'')">
                      <template slot="append">元取全款，默认 500元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="货运部">
                    <el-input v-model="delinfo.freight" maxlength="10" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="货运部电话">
                    <el-input v-model="delinfo.freightTel" maxlength="20"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收货人">
                    <el-input v-model="delinfo.consignee" maxlength="10" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收货电话" maxlength="20">
                    <el-input v-model="delinfo.consigneeTel"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="收货地址">
                    <el-input v-model="delinfo.consigneeAddress" maxlength="200" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="店长姓名">
                    <el-input v-model="delinfo.magname" maxlength="10" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="店长电话">
                    <el-input v-model="delinfo.magtel" maxlength="20"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="创建时间">
                    <el-input :disabled="true" v-model="delinfo.time"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="delinfo.mark == 0">
                  <el-form-item label="退商日期" prop="retime">
                    <el-date-picker
                      style="width: 100%;"
                      v-model="delinfo.retime"
                      type="date"
                      placeholder="选择退商日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="扣款通知">-->
<!--                    <el-radio-group v-model="delinfo.msgSwitch">-->
<!--                      <el-radio :label="0">关闭</el-radio>-->
<!--                      <el-radio :label="1">开启</el-radio>-->
<!--                    </el-radio-group>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="24">
                  <el-form-item label="注意事项">
                    <el-input v-model="delinfo.precautions" type="textarea" :autosize="{ minRows: 2, maxRows: 99 }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button type="primary" :loading="subLoading" @click="submitForm('delinfo')">立即提交</el-button>
                <!--<el-button @click="getData">重置</el-button>-->
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            经销商资质文件
            <MultiFileJXS :oldSpan="false" class="add-btn" :oldButton="false" :old="files" :key="fileKey" :showList="false" v-on:nameList="pushName"></MultiFileJXS>
          </div>
          <div class="card-content" v-loading="loading">
            <el-row :gutter="12">
              <el-card class="file-info" v-if="fileList.length === 0">
                <div class="main-info">
                  <i class="el-icon-document"/>
                </div>
                <div class="more-info">
                  <div class="info-row">
                    <span class="title">该经销商暂无文件</span>
                  </div>
                </div>
              </el-card>
              <el-col :span="3" v-for="(item,index) in fileList" :key='index'>
                <el-card shadow="hover" class="file-info" style="cursor:pointer;" @click.native="downFile(index)">
                  <div class="closeIcon">
                    <i class="el-icon-close" @click.stop="deleteFile(index)"></i>
                  </div>
                  <div class="corner">
                    <span>&nbsp;</span>
                  </div>
                  <div class="checkIcon">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="main-info">
                    <i class="el-icon-document"/>
                  </div>
                  <div class="more-info">
                    <div class="info-row">
                      <span class="title">{{item.dName}}</span>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div style="float: right;color:#F56C6C;margin-top: 20px">
              <span v-show="showTips">提示：文件修改后如未保存, 离开此页面后需重新操作&nbsp;&nbsp;</span>
              <el-button type="primary" @click="subfile">点击保存</el-button>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            经销商用户列表
            <el-button type="primary" @click="addUser" class="add-btn" icon="el-icon-plus">添加用户</el-button>
            <div class="search-mode">
              <input type="text" class="search-input" placeholder="关键字搜索" v-model="searchUser" />
              <el-button class="search-btn" icon="el-icon-search" @click="SearchUser"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loadingUser">
                <el-table
                  :data="tableDataUser"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="登录名"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#000">{{scope.row.username}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="姓名"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                      <svg-icon icon-class="client_man" class="user-sex" v-if="scope.row.sex === '男'" />
                      <svg-icon icon-class="client_women" class="user-sex" v-if="scope.row.sex === '女'" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="职位"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.positionname!=null&&scope.row.positionname!=''">{{scope.row.positionname}}</span>
                      <span v-if="scope.row.positionname==null||scope.row.positionname==''">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="导购员"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.isshop===1" style="color: #67C23A">开启</span>
                      <span v-else style="color:#F56C6C">关闭</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.tel!=null&&scope.row.tel!=''">{{scope.row.tel}}</span>
                      <span v-if="scope.row.tel==null||scope.row.tel==''">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="微信"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.wchat!=null&&scope.row.wchat!=''">{{scope.row.wchat}}</span>
                      <span v-if="scope.row.wchat==null||scope.row.wchat==''">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="邮箱"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.email!=null&&scope.row.email!=''">{{scope.row.email}}</span>
                      <span v-if="scope.row.email==null||scope.row.email==''">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="使用状态"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.userid==delinfo.userid"><i class="el-icon-star-on"></i> 主用户</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark==1">正常</el-tag>
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.mark==2">审核中</el-tag>
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.mark==3">未激活</el-tag>
                      <el-tag :disable-transitions="true" type="info" size="mini" v-if="scope.row.mark==4">已离职</el-tag>
                      <el-tag :disable-transitions="true" type="danger" size="mini" v-if="scope.row.mark==0">停用</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    fixed="right"
                    width="120">
                    <template slot-scope="scope">
                      <el-dropdown size="mini" @click="editUser(scope.row)" split-button icon="el-icon-edit">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="scope.row.mark===2" @click.native="auditUser(scope.row)"><i class="el-icon-check"></i> 审核通过</el-dropdown-item>
                          <el-dropdown-item @click.native="setMain(scope.row)"><i class="el-icon-star-off"></i> 设为主用户</el-dropdown-item>
<!--                          <el-dropdown-item v-if="scope.row.mark===3" @click.native="activeUser(scope.row)"><i class="el-icon-circle-check"></i> 激活用户</el-dropdown-item>-->
                          <el-dropdown-item @click.native="delUser(scope.row)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="totalUser>0"
                  background
                  @size-change="handleSizeChangeUser"
                  @current-change="handleCurrentChangeUser"
                  :current-page="currentPageUser"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSizeUser"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalUser">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            代理品牌
          </div>
          <div class="card-content" v-loading="loading">
            <el-row :gutter="12">
              <el-col :span="6" v-for="item in delinfo.brandlst">
                <el-card shadow="hover" class="brand-info">
                  <div class="main-info">
                    <el-image
                      style="width: 100%; height: 60px"
                      :src="item.brandlogo"
                      fit="contain"></el-image>
                  </div>
                  <div class="more-info">
                    <div class="info-row">
                      <span class="title">{{item.brandname}}</span>
                    </div>
                    <div class="info-row info-content">
                      <p><span>区域经理：</span>{{item.areaname}}</p>
                      <p><span>销售客服：</span>{{item.servicename}}</p>
                      <p><span>报价专员：</span>{{item.offername}}</p>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
<!--      <el-col class="card" style="padding-top: 20px">-->
<!--        <div class="card-body">-->
<!--          <div class="card-title">-->
<!--            扣款验证列表-->
<!--            <el-button type="primary" @click="addTel" class="add-btn" icon="el-icon-plus">添加号码</el-button>-->
<!--            <div class="search-mode">-->
<!--              <input type="text" class="search-input" placeholder="关键字搜索" v-model="searchTel" />-->
<!--              <el-button class="search-btn" icon="el-icon-search" @click="SearchTel"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="card-content" >-->
<!--            <el-row>-->
<!--              <el-col :span="24" v-loading="loadingTel">-->
<!--                <el-table-->
<!--                  :data="tableDataTel"-->
<!--                  :show-header="false"-->
<!--                  style="width: 100%">-->
<!--                  <el-table-column-->
<!--                    label="姓名"-->
<!--                    width="180"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span style="color:#99a9bf">姓名：</span>-->
<!--                      <span>{{scope.row.name}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column-->
<!--                    label="电话号码"-->
<!--                    width="280"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span style="color:#99a9bf">电话号码：</span>-->
<!--                      <span>{{scope.row.tel}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column-->
<!--                    label="操作">-->
<!--                    <template slot-scope="scope">-->
<!--                      <el-dropdown size="mini" @click="editTel(scope.row)" split-button icon="el-icon-edit">-->
<!--                        <i class="el-icon-edit"></i> 编辑-->
<!--                        <el-dropdown-menu slot="dropdown">-->
<!--                          <el-dropdown-item @click.native="delTel(scope.row)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除号码</el-dropdown-item>-->
<!--                        </el-dropdown-menu>-->
<!--                      </el-dropdown>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                </el-table>-->
<!--                <el-pagination-->
<!--                  v-if="totalTel>0"-->
<!--                  background-->
<!--                  @size-change="handleSizeChangeTel"-->
<!--                  @current-change="handleCurrentChangeTel"-->
<!--                  :current-page="currentPageTel"-->
<!--                  :page-sizes="[20, 50, 100]"-->
<!--                  :page-size="pageSizeTel"-->
<!--                  layout="total, sizes, prev, pager, next, jumper"-->
<!--                  :total="totalTel">-->
<!--                </el-pagination>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-col>-->
    </el-row>
    <el-dialog
      :title="editUserTitle"
      :visible.sync="editUserVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="userForm" :model="userForm" :rules="userRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="登录名" prop="username">
          <el-input
            v-model="userForm.username"
            minlength="11"
            maxlength="11"
            :disabled="userForm.userid!=null">
            <template slot="append">请填写手机号码</template>
          </el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input
            type="password"
            v-model="userForm.password"
            minlength="6"
            maxlength="16"
            :disabled="isEditPaw">
            <template slot="append" v-if="userForm.userid!=null">
              <el-switch v-model="isEditPaw" @change="pawSwitch"></el-switch>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="用户姓名" prop="name">
          <el-input
            maxlength="10"
            v-model="userForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userForm.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input
            minlength="11"
            maxlength="11"
            v-model="userForm.tel">
          </el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionid">
          <el-select v-model="userForm.positionid" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :label="item.name"
              :value="item.positionid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导购员" prop="isshop">
          <el-switch v-model="userForm.isshop"></el-switch>
          <span style="font-size: 12px;color: #9aaabf;margin-left: 10px">开启后将展示在门店小程序导购列表</span>
        </el-form-item>
        <el-form-item label="微信" prop="wchat">
          <el-input
            maxlength="20"
            v-model="userForm.wchat">
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            maxlength="60"
            v-model="userForm.email">
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEditUser('userForm')">立即提交</el-button>
          <el-button @click="editUserVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="editTelTitle"
      :visible.sync="editTelVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="telForm" :model="telForm" :rules="telRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input
            maxlength="10"
            v-model="telForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="tel">
          <el-input
            v-model="telForm.tel"
            minlength="11"
            maxlength="11">
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editTelloading" @click="subEditTel('telForm')">立即提交</el-button>
          <el-button @click="editTelVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="审核用户"
      :visible.sync="auditUserVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="登录名" prop="username">
          <el-input
            v-model="auditForm.username"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="用户姓名" prop="name">
          <el-input
            :disabled="true"
            v-model="auditForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionid">
          <el-select v-model="auditForm.positionid" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :label="item.name"
              :value="item.positionid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导购员" prop="isshop">
          <el-switch v-model="auditForm.isshop"></el-switch>
          <span style="font-size: 12px;color: #9aaabf;margin-left: 10px">开启后将展示在门店小程序导购列表</span>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="auditloading" @click="SubAudit('auditForm')">审核通过</el-button>
          <el-button @click="auditUserVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getDealerDetail,
  updateDealerInfo,
  getDealerUserList,
  updateDealerUserInfo,
  setMainOrDelDealerUser,
  getDealerTelList,
  editDealerTel,
  updateDealerInfoFile
} from '@/api/work'
import { getCity } from '@/utils/city'
import { validatePhoneNumber } from '@/utils/validate'
import { checkRegisterDealerUser, getDealerPositionList } from '@/api/dealer'
import MultiFileJXS from '@/components/upload/MultiFileJXS'
import { deleteSwatch } from '@/api/about/swatch'
import { getFileInfo } from '@/api/pub'
export default {
  name: 'DealerHomepage',
  computed: {
    user: getUser
  },
  components: {
    MultiFileJXS
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入6-16位的登录密码'))
      } else {
        callback()
      }
    }
    const validateCity = (rule, value, callback) => {
      if (this.city.length <= 0) {
        callback(new Error('请选择所在地区'))
      } else {
        callback()
      }
    }
    const validateGps = (rule, value, callback) => {
      if (this.delinfo.lng === null || this.delinfo.lng === undefined || this.delinfo.lng === '' || this.delinfo.lat === null || this.delinfo.lat === undefined || this.delinfo.lat === '') {
        callback(new Error('请选择门店定位'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      positionList: [],
      subLoading: false,
      auditloading: false,
      editloading: false,
      editTelloading: false,
      delid: '',
      delinfo: {
      },
      files: [],
      fileList: [],
      fileKey: '',
      showTips: false,
      cityoptions: getCity(),
      city: [],
      editRules: {
        allname: [{ required: true, message: '请输入经销商全称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
        mark: [{ required: true, message: '请选择店面状态', trigger: 'change' }],
        tel: [{ required: true, trigger: 'blur', validator: validateUsername }],
        city: [{ required: true, trigger: 'change', validator: validateCity }],
        gps: [{ required: true, trigger: 'change', validator: validateGps }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        // level: [{ required: true, message: '请选择客户级别', trigger: 'change' }],
        depositPer: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        depositLess: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        retime: [{ required: true, message: '请选择退商时间', trigger: 'change' }],
      },
      searchUser: '',
      loadingUser: false,
      tableDataUser: [],
      currentPageUser: 1,
      pageSizeUser: 20,
      totalUser: 0,
      auditUserVisible: false,
      editUserVisible: false,
      editUserTitle: '添加用户',
      isEditPaw: false,
      userForm: {
        userid: null,
        username: '',
        password: '',
        name: '',
        sex: '',
        positionid: '',
        isshop: false,
        tel: '',
        wchat: '',
        email: ''
      },
      auditForm: {
        userid: null,
        username: '',
        name: '',
        positionid: '',
        isshop: false
      },
      userRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        name: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        positionid: [{ required: true, message: '请选择职位', trigger: 'change' }],
        tel: [{ required: true, trigger: 'blur', validator: validateUsername }]
      },
      auditRules: {
        positionid: [{ required: true, message: '请选择职位', trigger: 'change' }]
      },
      searchTel: '',
      loadingTel: false,
      tableDataTel: [],
      currentPageTel: 1,
      pageSizeTel: 20,
      totalTel: 0,
      editTelVisible: false,
      editTelTitle: '添加扣款验证号码',
      telForm: {
        dtid: null,
        name: '',
        tel: ''
      },
      telRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateUsername }]
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.delid = this.$route.params && this.$route.params.id
    this.getPositionList()
    this.getData()
    this.getUserData()
    // this.getTelData()
  },
  methods: {
    flushMap() {
      if (this.delinfo.city.length > 0 && this.delinfo.address !== null && this.delinfo.address !== undefined && this.delinfo.address.trim() !== '') {
        const geocoder = new qq.maps.Geocoder()
        const address = `${this.delinfo.city[0]}` + `${this.delinfo.city[1]}` + `${this.delinfo.city[2]}` + `${this.delinfo.address}`
        const that = this
        geocoder.getLocation(address)
        geocoder.setComplete(function(result) {
          that.delinfo.lng = result.detail.location.lng
          that.delinfo.lat = result.detail.location.lat
          that.initMap()
        })
      } else {
        this.$message.error('请完善门店地址再进行定位')
      }
    },
    initMap() {
      var that = this
      this.$nextTick(() => {
        const txmap = this.$refs.map
        if (txmap !== null) {
          var center = new qq.maps.LatLng(that.delinfo.lat, that.delinfo.lng)
          var map = new qq.maps.Map(txmap, {
            center: center,
            zoom: 20
          })
          var anchor = new qq.maps.Point(35, 70),
            size = new qq.maps.Size(70, 70),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage('https://www.mulu.life/efile/upload/temp/map_marker.png', size, origin, anchor)
          var marker = new qq.maps.Marker({
            position: center,
            icon: icon,
            map: map,
            Draggable: true
          })
          qq.maps.event.addListener(marker, 'dragend', function() {
            var weizhi = marker.getPosition()
            that.delinfo.lng = weizhi.lng
            that.delinfo.lat = weizhi.lat
          })
          qq.maps.event.addListener(map, 'click', function(event) {
            that.delinfo.lng = event.latLng.getLng()
            that.delinfo.lat = event.latLng.getLat()
            var newcenter = new qq.maps.LatLng(that.delinfo.lat, that.delinfo.lng)
            marker.setPosition(newcenter)
          })
        }
      })
    },
    getPositionList() {
      getDealerPositionList().then(response => {
        this.positionList = response.data
      })
    },
    auditUser(row) {
      this.auditForm.userid = row.userid
      this.auditForm.username = row.username
      this.auditForm.name = row.name
      this.auditForm.positionid = ''
      this.auditForm.isshop = false
      this.auditUserVisible = true
    },
    SubAudit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.auditloading) {
            this.$confirm('审核通过 “' + this.auditForm.name + '” 用户, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.auditloading = true
              checkRegisterDealerUser({
                userid: this.auditForm.userid,
                positionid: this.auditForm.positionid,
                isshop: this.auditForm.isshop ? 1 : 0
              }).then(response => {
                this.$message({
                  message: '审核已通过',
                  type: 'success'
                })
                this.auditloading = false
                this.auditUserVisible = false
                this.getUserData()
              }).catch(() => {
                this.auditloading = false
              })
            }).catch(() => {})
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    getData() {
      this.loading = true
      getDealerDetail({ delid: this.delid }).then(response => {
        this.loading = false
        this.delinfo = response.data
        const oldcity = []
        if (this.delinfo.province) {
          oldcity.push(this.delinfo.province)
        }
        if (this.delinfo.city) {
          oldcity.push(this.delinfo.city)
        }
        if (this.delinfo.county) {
          oldcity.push(this.delinfo.county)
        }
        if (oldcity.length > 0) {
          this.city = oldcity
        }
        const resfiles = []
        for (let i = 0; i < response.data.filesList.length; i++) {
          const data = {
            dFileid: response.data.filesList[i].file_id,
            dPath: response.data.filesList[i].file_path,
            dName: response.data.filesList[i].file_name
          }
          resfiles.push(data)
        }
        this.fileList = resfiles
        this.fileKey = new Date().getTime().toString()
        const pageTitle = this.delinfo.allname
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.initMap()
      }).catch(() => {
        this.loading = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.subLoading) {
            this.subLoading = true
            const data = {
              delid: this.delinfo.delid,
              allname: this.delinfo.allname,
              name: this.delinfo.name,
              lng: this.delinfo.lng,
              lat: this.delinfo.lat,
              level: this.delinfo.level,
              province: this.city[0],
              city: this.city[1],
              county: this.city[2],
              address: this.delinfo.address,
              depositLess: this.delinfo.depositLess,
              depositPer: this.delinfo.depositPer,
              tel: this.delinfo.tel,
              fax: this.delinfo.fax,
              email: this.delinfo.email,
              freight: this.delinfo.freight,
              freightTel: this.delinfo.freightTel,
              storeArea: this.delinfo.storeArea,
              mark: this.delinfo.mark,
              consignee: this.delinfo.consignee,
              consigneeTel: this.delinfo.consigneeTel,
              consigneeAddress: this.delinfo.consigneeAddress,
              magname: this.delinfo.magname,
              magtel: this.delinfo.magtel,
              msgSwitch: this.delinfo.msgSwitch,
              precautions: this.delinfo.precautions,
              retime: this.delinfo.retime
            }
            updateDealerInfo(data).then(response => {
              this.$message({
                message: '经销商信息修改成功',
                type: 'success'
              })
              if (this.delinfo.mark === 0) {
                this.$alert('店面为已终止的经销商，该经销商所有用户都将无法登录！', '店面终止提示', { type: 'warning' })
              }
              this.subLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.subLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    SearchUser() {
      if (this.searchUser != null && this.searchUser.trim() !== '') {
        this.currentPageUser = 1
        this.getUserData()
      } else {
        this.searchUser = ''
        this.getUserData()
      }
    },
    SearchTel() {
      if (this.searchTel != null && this.searchTel.trim() !== '') {
        this.currentPageTel = 1
        this.getTelData()
      } else {
        this.searchTel = ''
        this.getTelData()
      }
    },
    getUserData() {
      this.loadingUser = true
      const data = {
        delid: this.delid,
        content: this.searchUser,
        page: this.currentPageUser,
        limit: this.pageSizeUser
      }
      getDealerUserList(data).then(response => {
        this.loadingUser = false
        this.tableDataUser = response.data
        this.totalUser = response.total
      }).catch(() => {
        this.loadingUser = false
      })
    },
    getTelData() {
      this.loadingTel = true
      const data = {
        delid: this.delid,
        content: this.searchTel,
        page: this.currentPageTel,
        limit: this.pageSizeTel
      }
      getDealerTelList(data).then(response => {
        this.loadingTel = false
        this.tableDataTel = response.data
        this.totalTel = response.total
      }).catch(() => {
        this.loadingTel = false
      })
    },
    handleSizeChangeUser(val) {
      this.pageSizeUser = val
      this.getUserData()
    },
    handleSizeChangeTel(val) {
      this.pageSizeTel = val
      this.getTelData()
    },
    handleCurrentChangeUser(val) {
      this.currentPageUser = val
      this.getUserData()
    },
    handleCurrentChangeTel(val) {
      this.currentPageTel = val
      this.getTelData()
    },
    addUser() {
      this.editUserTitle = '添加用户'
      this.userForm.userid = null
      this.userForm.username = ''
      this.userForm.password = ''
      this.userForm.name = ''
      this.userForm.sex = ''
      this.userForm.positionid = ''
      this.userForm.isshop = false
      this.userForm.tel = ''
      this.userForm.wchat = ''
      this.userForm.email = ''
      this.isEditPaw = false
      this.userRules.password[0].required = true
      this.editUserVisible = true
    },
    addTel() {
      this.editTelTitle = '添加扣款验证号码'
      this.telForm.dtid = null
      this.telForm.name = ''
      this.telForm.tel = ''
      this.editTelVisible = true
    },
    editUser(row) {
      this.editUserTitle = '编辑用户'
      this.userForm.userid = row.userid
      this.userForm.username = row.username
      this.userForm.password = '****************'
      this.isEditPaw = true
      this.userForm.name = row.name
      this.userForm.isshop = row.isshop === 1 ? true : false
      this.userForm.positionid = row.positionid
      this.userForm.sex = row.sex
      this.userForm.tel = row.tel
      this.userForm.wchat = row.wchat
      this.userForm.email = row.email
      this.userRules.password[0].required = false
      this.editUserVisible = true
    },
    editTel(row) {
      this.editTelTitle = '编辑扣款验证号码'
      this.telForm.dtid = row.dtid
      this.telForm.name = row.name
      this.telForm.tel = row.tel
      this.editTelVisible = true
    },
    pawSwitch() {
      if (this.isEditPaw) {
        this.$refs['userForm'].clearValidate(['password'])
        this.userRules.password[0].required = false
        this.userForm.password = '****************'
      } else {
        this.userForm.password = ''
        this.userRules.password[0].required = true
      }
    },
    setMain(row) {
      this.$confirm('设置 “' + row.name + '” 为此经销商主用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setMainOrDelDealerUser({ userid: row.userid, delid: this.delid, type: 1 }).then(response => {
          this.delinfo.userid = row.userid
          this.$message({
            message: '设置经销商主用户成功',
            type: 'success'
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    activeUser(row) {
      this.$confirm('您确定激活此用户吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setMainOrDelDealerUser({ userid: row.userid, delid: this.delid, type: 2 }).then(response => {
          this.$message({
            message: '激活成功',
            type: 'success'
          })
          this.getUserData()
        }).catch(() => {})
      }).catch(() => {})
    },
    delUser(row) {
      this.$confirm('删除 “' + row.name + '” 经销商用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setMainOrDelDealerUser({ userid: row.userid, delid: this.delid, type: 0 }).then(response => {
          this.$message({
            message: '经销商用户已删除',
            type: 'success'
          })
          this.getUserData()
        }).catch(() => {})
      }).catch(() => {})
    },
    delTel(row) {
      this.$confirm('删除 “' + row.name + '” 扣款验证号码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        editDealerTel({ dtid: row.dtid, type: 2 }).then(response => {
          this.$message({
            message: response.msg,
            type: 'success'
          })
          this.getTelData()
        }).catch(() => {})
      }).catch(() => {})
    },
    subEditUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let paw = ''
            if (!this.isEditPaw) {
              paw = this.userForm.password
            }
            const data = {
              userid: this.userForm.userid,
              delid: this.delid,
              username: this.userForm.username,
              positionid: this.userForm.positionid,
              isshop: this.userForm.isshop ? 1 : 0,
              password: paw,
              name: this.userForm.name,
              sex: this.userForm.sex,
              tel: this.userForm.tel,
              wchat: this.userForm.wchat,
              email: this.userForm.email
            }
            updateDealerUserInfo(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editUserVisible = false
              this.editloading = false
              this.getUserData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subEditTel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editTelloading) {
            this.editTelloading = true
            let data = {}
            if (this.telForm.dtid != null) {
              data = {
                dtid: this.telForm.dtid,
                delid: this.delid,
                name: this.telForm.name,
                tel: this.telForm.tel,
                type: 1
              }
            } else {
              data = {
                delid: this.delid,
                name: this.telForm.name,
                tel: this.telForm.tel,
                type: 0
              }
            }
            editDealerTel(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editTelVisible = false
              this.editTelloading = false
              this.getTelData()
            }).catch(() => {
              this.editTelloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    pushName(msg) {
      this.showTips = true
      this.fileList.push(msg)
    },
    deleteFile(index) {
      this.$confirm(`此操作将移除 ${this.fileList[index].dName} , 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileList.splice(index, 1)
        this.showTips = true
        this.$message({
          type: 'success',
          message: '移除成功！'
        })
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消'
        })
      })
    },
    subfile() {
      this.$confirm('您确定要保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 当文件发生改变才会向后台发送请求
        if (this.showTips) {
          const fileIds = []
          this.fileList.forEach((item) => {
            fileIds.push(item.dFileid)
          })
          const data = {
            delid: this.delid,
            fileStr: fileIds ? fileIds.join(',') : ''
          }
          updateDealerInfoFile(data).then(response => {
            this.$message({
              type: 'success',
              message: response.msg
            })
          })
        } else {
          this.$message({
            type: 'success',
            message: '保存成功！'
          })
        }
        this.showTips = false
      }).catch(() => {})
    },
    downFile(index) {
      const downid = this.fileList[index].dFileid
      getFileInfo({ fileid: downid }).then(response => {
        /* this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a', {
              attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }
            }, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.dealer-homepage-container {
  .file-info{
    margin:6px 0;
    position: relative;
    .closeIcon {
      position: absolute;
      top: 2px;
      right: 3px;
      height: 15px;
      width: 15px;
      z-index: 1;
      i {
        color: #606266 !important;
        margin-left: 50%;
        margin-top: 50%;
        translate: -50% -50%;
      }
    }
    .closeIcon:hover{
      i{
        font-weight: bold;
      }
    }
    .checkIcon {
      position: absolute;
      top: 2px;
      right: 3px;
      height: 15px;
      width: 15px;
      z-index: 3;
      i {
        color: #fff !important;
        margin-left: 50%;
        margin-top: 50%;
        translate: -50% -50%;
      }
    }
    .corner {
      z-index: 2;
      overflow: hidden;
      line-height:24px;
      background:#13ce66;
      position:absolute;
      top: -2px;
      right: -2px;
      z-Index:2;
      padding:0 2em;
      -webkit-transform-origin:left bottom;
      -moz-transform-origin:left bottom;
      transform-origin:left bottom;
      -webkit-transform:translate(29.29%,-100%) rotate(45deg);
      -moz-transform:translate(29.29%,-100%) rotate(45deg);
      transform:translate(29.29%,-100%) rotate(45deg);
      text-indent:0;
    }
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
      i{
        font-size: 60px!important;
        margin-bottom: 10px;
      }
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
  .file-info:hover{
    color: #409eff;
    .checkIcon{
      z-index: -1;
    }
    .corner{
      z-index: -2;
    }
  }
  .brand-info{
    margin:6px 0;
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
  .add-btn{
    position: relative;
    float: right;
    margin-left: 10px;
    margin-top: -10px;
  }
  .search-mode{
    width: 300px;
    position: relative;
    float: right;
    margin-top: -10px;
    .search-input{
      background-color: #F2F6FC;
      border:0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      color: #606266;
      padding: 0 40px 0 15px;
      -webkit-appearance: none;
      font-size: 12px;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      &::-webkit-input-placeholder {
        color: #C0C4CC;
      }
      &::-ms-input-placeholder {
        color: #C0C4CC;
      }
    }
    .search-btn{
      position: absolute;
      right: 0;
      height: 40px;
      width: 40px;
      line-height: 40px;
      top: 0;
      border: 0;
      background: transparent;
      text-align: center;
      padding: 0;
    }
  }
  .card-content{
    .user-sex{
      width: 16px!important;
      height: 16px!important;
      vertical-align: -4px!important;
    }
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
}
</style>
